import React, { useState, useEffect } from "react";
import {
  Radio,
  Typography,
  Form,
  Row,
  Divider,
  Select,
  Input,
  Button,
  DatePicker,
  InputNumber,
  Space,
  Tooltip
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  getFields,
  saveStep,
  updateStep,
  disableQoute,
  checkQoute,
} from "../../../store/policy";
import { checkEmailExists, resetEmailCacheForStep, setCurrentStep } from "../../../store/medicalAssessmentSlice";
import styles from "./index.module.css";
import userTick from "../../../utils/img/userTick.png";
import helpIcon from "../../../utils/img/helpIcon.png";
import moment from "moment";
import { validationRules } from "../../common/Utils";
import CustomInput from "../../common/CustomInput";
import { ArrowLeft, ArrowRight, Users, User, Calendar, Hash, Info, HelpCircle } from "lucide-react";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const { Option } = Select;
const { Title, Text, Paragraph } = Typography;

const dateFormat = 'YYYY-MM-DD';

function EnhancedStep2({ setCurrent, current }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [principalMember, setPrincipalMember] = useState(true);
  const [spouse, setSpouse] = useState(true);
  const [children, setChildren] = useState(true);
  const [childrenCount, setChildrenCount] = useState(0);
  const [sortedFields, setSortedFields] = useState([]);
  const [allFields, setAllFields] = useState([]);
  const existingValues = sessionStorage.getItem("values");
  const coverageCountry = localStorage.getItem('coverageCountry') ? localStorage.getItem('coverageCountry') : '';

  const { steps, fields } = useSelector((state) => state.policySlice);
  const { emailCheckStatus } = useSelector(
    (state) => state.medicalAssessment
  );

  const style = {
    customRadio: {
      backgroundColor: "#f0fdfa",
      padding: "10px 16px",
      borderRadius: "10px",
      border: "1px solid #99f6e4",
      transition: "all 0.2s ease",
    },
  };

  const principalMembers = [
    { text: "You're now a principal member", icon: userTick },
    {
      text: "This person will be considered as a principal member",
      icon: helpIcon,
    },
  ];

  const stepId = steps?.find((s) => s?.step_number === current)?.id;

  useEffect(()=>{console.log(stepId)},[stepId])

  useEffect(() => {
    if (stepId) {
      dispatch(setCurrentStep(stepId));
      dispatch(resetEmailCacheForStep(stepId));
    }
  }, [stepId, dispatch]);

  const submitForm = async () => {
    const values = form.getFieldsValue();

    const emailFields = Object.entries(values).filter(([key, value]) => {
      return (key.includes('email') || key.includes('mail')) && value;
    });

    for (const [fieldName, value] of emailFields) {
      const result = await dispatch(checkEmailExists({
        email: value,
        stepId: stepId
      }));

      if (result.payload?.exists) {
        return;
      }
    }

    if (childrenCount) {
      form.setFieldValue('principal_children_count', childrenCount);
    }

    form
      .validateFields()
      .then(() => {
        let values = form.getFieldsValue();
        for (let entity in values) {
          if (entity === "principal_dob" || entity === "principal_spouse_age" || entity === "dob") {
            values[entity] = moment(new Date(values[entity])).format(
              "YYYY-MM-DD"
            );
          }
        }

        if (
          existingValues &&
          JSON.parse(existingValues).find(
            (step) =>
              step.step_id === steps.find((s) => s?.step_number === current)?.id
          )
        ) {
          dispatch(
            updateStep({
              userId: JSON.parse(sessionStorage.getItem("user"))?.userId,
              stepId: steps.find((s) => s?.step_number === current)?.id,
              parameters: allFields
                ?.filter(
                  (f) =>
                    f.field_name &&
                    (values[f.field_name] || values[f.field_name] === false)
                )
                ?.map((field, i) => {
                  return {
                    field_id: field?.id,
                    key: field?.field_name,
                    value: values[field?.field_name],
                  };
                }),
            })
          );
          dispatch(disableQoute());
          localStorage.removeItem('lastStep')
        } else {
          dispatch(
            saveStep({
              source: steps.find((s) => s?.step_number === current)
                ?.step_source,
              user_id: JSON.parse(sessionStorage.getItem("user"))?.userId,
              step_id: steps.find((s) => s?.step_number === current)?.id,
              parameters: allFields
                ?.filter(
                  (f) =>
                    f.field_name &&
                    (values[f.field_name] || values[f.field_name] === false)
                )
                ?.map((field, i) => {
                  return {
                    field_id: field?.id,
                    key: field?.field_name,
                    value: values[field?.field_name],
                  };
                }),
            })
          );
          dispatch(disableQoute());
        }
      })
      .then(() => setCurrent(3))
      .catch((err) => console.log(err));
  };

  useEffect(()=>{console.log(steps,current)},[steps,current])

  useEffect(() => {
    if (
      steps &&
      steps.find((s) => s?.step_number === current) &&
      steps.find((s) => s?.step_number === current).form_id &&
      steps.find((s) => s?.step_number === current).id
    ) {
      console.log("entering")
      dispatch(
        getFields({
          formId: steps.find((s) => s?.step_number === current).form_id,
          stepId: steps.find((s) => s?.step_number === current).id,
        })
      ).then((res) => {
        const localFields = res?.payload &&
          Array.isArray(res?.payload) && [...res?.payload];
        setSortedFields(
          localFields?.sort((a, b) => a?.
            field_sequence - b?.
            field_sequence)
        );

        const includeConditionalFields = localFields
          ?.sort((a, b) => (a?.id).localeCompare(b?.id))
          ?.reduce((acc, curr) => {
            acc = [...acc, curr];
            if (
              curr?.conditional_fields &&
              Object.values(curr?.conditional_fields)?.some(
                (arr) => arr && Array.isArray(arr) && arr.length > 0
              )
            ) {
              let conditionalFields = Object.values(curr?.conditional_fields)
                ?.filter((arr) => arr.length > 0)
                .flatMap((arr) => arr);
              acc = [...acc, ...conditionalFields];
            }
            return acc;
          }, []);
        setAllFields(includeConditionalFields);
      });
    }
  }, [steps]);

  useEffect(() => {
    if (
      existingValues &&
      JSON.parse(existingValues)?.find(
        (step) =>
          step.step_id === steps.find((s) => s?.step_number === current)?.id
      )
    ) {
      const values = JSON.parse(existingValues).find(
        (step) =>
          step.step_id === steps.find((s) => s?.step_number === current)?.id
      ).parameters;
      const obj = new Object();
      for (let key of values) {
        if (key.key === "covering_yourself") {
          setPrincipalMember(key.value === true ? true : false);
        }
        if (key.key === "principal_spouse") {
          setSpouse(key.value === true ? true : false);
        }
        if (key.key === "principal_children") {
          setChildren(key.value === true ? true : false);
        }
        if (key.key === "principal_children_count") {
          setChildrenCount(key.value && parseInt(key.value));
        }
        if (
          (key.key.includes("principal_dob") ||
            key.key.includes("principal_spouse_age") || key.key.includes("dob")) &&
          key.value
        ) {
          obj[key.key] = moment(key.value, "YYYY-MM-DD");
        } else {
          obj[key.key] = key.value;
        }
      }
      form.setFieldsValue(obj);
    } else if (sortedFields.length > 0) {
      const obj = new Object();

      for (let key of sortedFields) {
        if (key?.field_name === "covering_yourself") {
          obj[key?.field_name] = true;
          setPrincipalMember(true);
        }
        if (key?.field_name === "principal_spouse") {
          obj[key?.field_name] = false;
          setSpouse(false);
        }
        if (key?.field_name === "principal_children") {
          obj[key?.field_name] = false;
          setChildren(false);
        }
      }
      form.setFieldsValue(obj);
    }
  }, [steps, sortedFields]);

  const getFieldIcon = (fieldType) => {
    switch (fieldType) {
      case "text":
        return <User size={15} color="#028D86" />;
      case "date":
        return <Calendar size={15} color="#028D86" />;
      case "dropdown":
        return <Users size={15} color="#028D86" />;
      case "number":
        return <Hash size={15} color="#028D86" />;
      default:
        return <HelpCircle size={15} color="#028D86" />;
    }
  };

  return (
    <div className={styles.stepWrapper}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.cardIcon}>
            <Users size={20} />
          </div>
          <div>
            <Title level={4} className={styles.cardTitle}>Family Coverage Details</Title>
            <Text className={styles.cardDesc}>
              Tell us who will be covered under this policy
            </Text>
          </div>
        </div>

        <div className={styles.cardBody}>
          <Form layout="vertical" className={styles.formContainer} form={form}>
            {sortedFields &&
              sortedFields.length > 0 &&
              sortedFields.map((field, index) => {
                return (
                  <React.Fragment key={index}>
                    <Form.Item
                      name={field?.field_name}
                      label={<span className={styles.fieldLabel}>{field?.label}</span>}
                      validateTrigger="onChange"
                      dependencies={[field?.field_name]}
                      rules={validationRules(field?.validation, field?.label)}>
                      <Radio.Group
                        options={
                          field?.values
                            ? field?.values?.map((field) => {
                              return {
                                label: field?.name,
                                value: field?.value === "1" ? true : false,
                                style: style.customRadio,
                              };
                            })
                            : []
                        }
                        onChange={(e) => {
                          if (index === 0) {
                            setPrincipalMember(e.target.value);
                          } else if (index === 1) {
                            setSpouse(e.target.value);
                          } else if (index === 2) {
                            setChildren(e.target.value);
                          }
                        }}
                      />
                    </Form.Item>

                    {index === 0 && !principalMember && (
                      <div className={styles.infoAlert}>
                        <Info size={16} color="#028D86" />
                        <span>{fields?.[0]?.conditional_fields?.["No"]?.[0]?.information}</span>
                      </div>
                    )}

                    {index === 0 && (
                      <div className={styles.memberBadge}>
                        <img
                          src={principalMember ? principalMembers[0].icon : principalMembers[1].icon}
                          alt=""
                          className={styles.memberBadgeIcon}
                        />
                        <Text className={styles.memberBadgeText}>
                          {principalMember ? principalMembers[0].text : principalMembers[1].text}
                        </Text>
                      </div>
                    )}

                    {index === 0 && principalMember && (
                      <div className={styles.detailsSection}>
                        <div className={styles.sectionHeader}>
                          <User size={16} color="#028D86" />
                          <Title level={5} className={styles.sectionTitle}>Principal Member Details</Title>
                        </div>
                        <div className={styles.detailsGrid}>
                          {field?.conditional_fields?.["Yes"]
                            ?.filter((type) => type?.type === "text" || type?.type === "date" || type?.type === "number")
                            ?.map((subField, i) => {
                              return (
                                <Form.Item
                                  key={i}
                                  label={subField?.heading ?
                                    <Space direction="vertical" size={0}>
                                      <div className={styles.fieldLabel} style={{ gap: '10px' }}>
                                        {subField?.heading}
                                        <Tooltip title="Additional information about this field">
                                          <HelpCircle size={14} color="#94a3b8" style={{ cursor: 'help' }} />
                                        </Tooltip>
                                      </div>
                                      <div style={{ fontSize: '0.85rem', color: '#64748b' }}>{subField?.label}</div>
                                    </Space> :
                                    <span className={styles.fieldLabel}>
                                      {getFieldIcon(subField?.type)}
                                      {subField?.label}
                                    </span>
                                  }
                                  id={subField?.id}
                                  name={subField?.field_name}
                                  dependencies={[subField?.field_name]}
                                  validateTrigger="onChange"
                                  rules={validationRules(subField?.validation, subField?.label)}
                                  style={{ gridColumn: subField?.type === "date" && 'span 2' }}
                                >
                                  {subField?.type === "text" ? (
                                    <Input
                                      allowClear
                                      className={styles.fieldInput}
                                      value={subField?.value}
                                      placeholder={`Enter ${subField?.label.toLowerCase()}`}
                                    />
                                  ) : subField?.type === "date" ? (
                                    <DatePicker
                                      allowClear
                                      className={styles.fieldDatePicker}
                                      format={"YYYY-MM-DD"}
                                      maxDate={dayjs().subtract(18, 'year')}
                                      disabledDate={(current) => {
                                        return (
                                          current &&
                                          (current > moment().endOf("day") ||
                                            current > moment().subtract(18, "years").endOf("day"))
                                        );
                                      }}
                                    />
                                  ) : subField?.type === "number" ? (
                                    <CustomInput
                                      value={subField?.value}
                                      placeholder={`Enter ${subField?.label.toLowerCase()}`}
                                      units={subField.unit}
                                      type={'number'}
                                      className={styles.fieldInput}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Form.Item>
                              );
                            })}
                        </div>
                      </div>
                    )}

                    {index === 0 && !principalMember && (
                      <div className={styles.detailsSection}>
                        <div className={styles.sectionHeader}>
                          <User size={16} color="#028D86" />
                          <Title level={5} className={styles.sectionTitle}>Principal Member Details</Title>
                        </div>
                        <div className={styles.detailsGrid}>
                          {field?.conditional_fields?.["No"]
                            ?.filter((type) => type?.type === "text" || type?.type === "date" || type?.type === "dropdown" || type?.type === "number")
                            ?.map((subField, i) => {
                              return (
                                <Form.Item
                                  key={i}
                                  label={subField?.heading ?
                                    <Space direction="vertical" size={0}>
                                      <div className={styles.fieldLabel} style={{ gap: '10px' }}>
                                        {subField?.heading}
                                        <Tooltip title="Additional information about this field">
                                          <HelpCircle size={14} color="#94a3b8" style={{ cursor: 'help' }} />
                                        </Tooltip>
                                      </div>
                                      <div style={{ fontSize: '0.85rem', color: '#64748b' }}>{subField?.label}</div>
                                    </Space> :
                                    <span className={styles.fieldLabel}>
                                      {getFieldIcon(subField?.type)}
                                      {subField?.label}
                                    </span>
                                  }
                                  id={subField?.id}
                                  name={subField?.field_name}
                                  dependencies={[subField?.field_name]}
                                  validateTrigger="onChange"
                                  rules={validationRules(subField?.validation, subField?.label)}
                                  style={{ gridColumn: (subField?.type === "dropdown" || subField?.type === "date") && 'span 2' }}
                                >
                                  {subField?.type === "dropdown" ? (
                                    <Select
                                      allowClear
                                      placeholder={`Select ${subField?.label.toLowerCase()}`}
                                      options={subField?.dropdowns?.filter(r => r?.regions?.find(r => r === coverageCountry))?.[0]?.values?.map(opt => { return { label: opt?.name, value: opt?.value } })}
                                      style={{ gridColumn: 'span 1' }}
                                      className={styles.fieldSelect}
                                      value={field?.value}
                                      showSearch
                                      optionFilterProp="label"
                                    />
                                  ) : subField?.type === "text" ? (
                                    <Input
                                      allowClear
                                      className={styles.fieldInput}
                                      value={subField?.value}
                                      placeholder={`Enter ${subField?.label.toLowerCase()}`}
                                    />
                                  ) : subField?.type === "date" ? (
                                    <DatePicker
                                      className={styles.fieldDatePicker}
                                      format={"YYYY-MM-DD"}
                                      maxDate={dayjs().subtract(18, 'year')}
                                      disabledDate={(current) => {
                                        return (
                                          current &&
                                          (current > moment().endOf("day") ||
                                            current > moment().subtract(18, "years").endOf("day"))
                                        );
                                      }}
                                    />
                                  ) : subField?.type === "number" ? (
                                    <CustomInput
                                      value={subField?.value}
                                      placeholder={`Enter ${subField?.label.toLowerCase()}`}
                                      units={subField.unit}
                                      type={'number'}
                                      className={styles.fieldInput}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Form.Item>
                              );
                            })}
                        </div>
                      </div>
                    )}

                    {index === 1 && spouse && (
                      <div className={styles.detailsSection}>
                        <div className={styles.sectionHeader}>
                          <Users size={16} color="#028D86" />
                          <Title level={5} className={styles.sectionTitle}>Spouse Details</Title>
                        </div>
                        <div className={styles.detailsGrid}>
                          {field?.conditional_fields?.["Yes"]?.map((subField, i) => {
                            return (
                              <Form.Item
                                key={i}
                                label={
                                  <span className={styles.fieldLabel}>
                                    {getFieldIcon(subField?.type)}
                                    {subField?.label}
                                  </span>
                                }
                                id={subField?.id}
                                name={subField?.field_name}
                                dependencies={[subField?.field_name]}
                                validateTrigger="onChange"
                                rules={validationRules(subField?.validation, subField?.label)}>
                                {subField?.type === "dropdown" ? (
                                  <Select
                                    allowClear
                                    className={styles.fieldSelect}
                                    placeholder={`Select ${subField?.label.toLowerCase()}`}
                                    options={field?.dropdowns?.filter(r => r?.regions?.find(r => r === coverageCountry))?.[0]?.values?.map(opt => { return { label: opt?.name, value: opt?.value } })}
                                    showSearch
                                    optionFilterProp="label"
                                  />
                                ) : subField?.type === "date" ? (
                                  <DatePicker
                                    className={styles.fieldDatePicker}
                                    format={"YYYY-MM-DD"}
                                    maxDate={dayjs().subtract(18, 'year')}
                                    disabledDate={(current) => {
                                      return (
                                        current &&
                                        (current > moment().endOf("day") ||
                                          current > moment().subtract(18, "years").endOf("day"))
                                      );
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </Form.Item>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {index === 2 && children && (
                      <div className={styles.detailsSection}>
                        <div className={styles.sectionHeader}>
                          <Users size={16} color="#028D86" />
                          <Title level={5} className={styles.sectionTitle}>Children Details</Title>
                        </div>
                        {field?.conditional_fields?.["Yes"]?.map((subField, i) => {
                          return (
                            <Form.Item
                              key={i}
                              label={
                                <span className={styles.fieldLabel}>
                                  {getFieldIcon(subField?.type)}
                                  {subField?.label}
                                </span>
                              }
                              id={subField?.id}
                              validateTrigger="onChange"
                              dependencies={[subField?.field_name]}
                              name={subField?.field_name}
                              rules={validationRules(subField?.validation, subField?.label)}
                            >
                              {subField?.type === "number" ? (
                                <>
                                  <Input
                                    allowClear
                                    className={styles.fieldInput}
                                    value={childrenCount}
                                    onChange={(e) => {
                                      if (!isNaN(parseInt(e.target.value)) || !e.target.value) {
                                        setChildrenCount(e.target.value)
                                      }
                                    }}
                                    placeholder={`Enter ${subField?.label.toLowerCase()}`}
                                    min={subField?.validation?.min}
                                    max={subField?.validation?.max}
                                  />
                                  {subField?.alert_message && (
                                    <div className={styles.alertBox}>
                                      <Info size={14} color="#d97706" />
                                      <span>{subField?.alert_message}</span>
                                    </div>
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                            </Form.Item>
                          );
                        })}
                      </div>
                    )}

                    {(index === 0 || index === 1) && <div className={styles.sectionDivider} />}
                  </React.Fragment>
                );
              })}
          </Form>

          <div className={styles.actions}>
            <Button
              onClick={() => setCurrent((curr) => curr - 1)}
              className={styles.backBtn}
              size="large"
            >
              <ArrowLeft size={16} />
              <span>Back</span>
            </Button>
            <Button
              type="primary"
              onClick={submitForm}
              className={styles.continueBtn}
              loading={emailCheckStatus === 'loading'}
              size="large"
            >
              <span>Continue</span>
              <ArrowRight size={16} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnhancedStep2;
